/**
 * Put a URL in the address bar as a new history entry, without an Inertia visit.
 *
 * The state must be null. Inertia takes any other state to be one of its own pages: on a back/forward load or a
 * restored tab it renders `history.state` in place of the page the server sent, and on popstate it resolves
 * `state.component`. An empty object has no component, so either one fails with "Page not found:
 * ./Pages/undefined.tsx", and the first leaves a blank screen. With null, Inertia renders the server's page, which
 * already opens the node the URL names.
 */
export function pushUrl(url: string): void {
    window.history.pushState(null, '', url)
}
